import { es, enUS } from "date-fns/locale";

export const getLocaleLanguage = (code) => {
  const languages = {
    es: es,
    en: enUS
  }

  return languages[code] || "es";
}